import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CEUPricingViewModel, PurchaseCEUsViewModel } from 'src/app/_models/generatedModels';
import { CEUService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'bxl-purchase-ceus-modal',
  templateUrl: 'purchase-ceus-modal.component.html',
})
export class PurchaseCeusModalComponent implements OnInit {
  initialized = false;
  @ViewChild('myForm') myForm: FormGroupDirective;
  submitComplete: Promise<{}> | undefined;
  @Input() certificationBodyId: number;
  @Input() conferenceId: number;
  public promoCode: string;
  public actualPrice: number = 0;
  public cardNumber: string;
  public expMo: string;
  public expYr: string;
  public cvv: string;

  errorMessage: string;
  pricing: CEUPricingViewModel;
  constructor(private activeModal: NgbActiveModal, private zone: NgZone, private ceuService: CEUService, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.ceuService.getCEUPricesForBody(this.conferenceId, this.certificationBodyId).subscribe(
      (result) => {
        this.pricing = result;
        this.initialized = true;
      },
      (error) => {
        this.errorMessage = error.error[0];
        this.initialized = true;
      }
    );
  }

  onCancel() {
    this.activeModal.dismiss();
  }

  onSave() {
    this.errorMessage = '';
    if (!this.myForm.valid) {
      this.myForm.form.markAllControlsDirty();
      return;
    }

    this.submitComplete = new Promise((resetButton: any, reject) => {
      this.purchasePackage(resetButton);
    });
  }

  purchasePackage(resetButton) {
    let card = { number: this.cardNumber, exp_month: this.expMo, exp_year: this.expYr, cvc: this.cvv };
    var model = new PurchaseCEUsViewModel();
    (<any>window).Stripe.card.createToken(card, (status: number, response: any) => {
      if (status === 200) {
        model.cardToken = response.id;
        this.zone.run(() => {
          this.ceuService.payForCEUs(this.conferenceId, this.certificationBodyId, model).subscribe(
            (result) => {
              if (!result) {
                resetButton();
                this.errorMessage = 'Unable to process transaction';
                return;
              }
              resetButton();
              // fbq('track', 'Purchase', { value: this.pckg.price, currency: 'USD' });
              this.toaster.messageDialog('Your purchase has been completed. You will receive a confirmation email shortly', 'Thank You!').subscribe();
              this.activeModal.close();
            },
            (error) => {
              resetButton();
              this.errorMessage = error.error[0];
            }
          );
        });
      } else {
        resetButton();
        this.errorMessage = response.error.message;
      }
    });
  }
}
